module.exports = __webpack_public_path__ + "static/media/logo.d6e33f59.png";